import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light";
import { GradientCard } from "../../components";
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../../constants"
import { Trans, useTranslation } from "react-i18next";
import Focality01 from '../../../../assets/images/svgs/identifyingGA/focality_01.png.svg';
import Focality02 from '../../../../assets/images/svgs/identifyingGA/focality_02.png.svg';
import LesionSize01 from '../../../../assets/images/svgs/identifyingGA/lesion_size_01.png.svg';
import LesionSize02 from '../../../../assets/images/svgs/identifyingGA/lesion_size_02.png.svg';
import LocationSize01 from '../../../../assets/images/svgs/identifyingGA/location_01.svg';
import LocationSize02 from '../../../../assets/images/svgs/identifyingGA/location_02.png.svg';
import TransMsg from './transMessage';

const styles = {
    cardItemBox: {
        backgroundColor: "#fff",
        flex: 1,
        px: "4px",
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)'
    }
}
const Progression = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    
    const progressionData = {
        title: t(TransMsg.PROGRESSION_TITLE),
        description: t(TransMsg.PROGRESSION_DESCRIPTION),
        notes: t(TransMsg.PROGRESSION_NOTES),
        contentData: [
            {
                "title": "Lesion Size",
                "footerLeft": "Small\nBaseline Lesions",
                "footerRight": "Large\nBaseline Lesions",
                "slowerProgressionImage": LesionSize01,
                "fasterProgressionImage": LesionSize02,
                "id": 0
            },
            {
                "title": "Location",
                "footerLeft": "Foveal",
                "footerRight": "Non-Foveal",
                "slowerProgressionImage": LocationSize01,
                "fasterProgressionImage": LocationSize02,
                "id": 1
            },
            {
                "title": "Focality",
                "footerLeft": "Unifocal",
                "footerRight": "Multifocal",
                "slowerProgressionImage": Focality01,
                "fasterProgressionImage": Focality02,
                "id": 2
            }
        ]
    }

    return (
        <Box textAlign={"center"} px="31px" py={"41px"} sx={{ backgroundColor: "#F8F8F8" }} display="flex" flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%">
                <Typography sx={{ ...theme.typography.components.sectionTitle }}>
                    {progressionData.title}
                </Typography>

                <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "24px" }}>
                    <Trans
                        i18nKey={progressionData.description}
                        components={{ sup: <sup /> }} />
                </Typography>

                <Box display={"flex"} mt={"24px"} gap={"1rem"} flexWrap={"wrap"} px={isMobileX ? "10px" : "none"}>
                    {progressionData.contentData.map((item) => {
                        return (
                            <Box sx={styles.cardItemBox} flexWrap={"wrap"} key={item.id}>
                                <Box sx={{ mt: "23px", }}>
                                    <Typography sx={{ ...theme.typography.montseratBodySemiBold, fontSize: "14px", color: "#4B69F1" }}>
                                        {item.title}
                                    </Typography>
                                </Box>
                                <Box sx={{ background: 'linear-gradient(135deg,rgb(214, 208, 225) 50%,rgb(244, 241, 250) 90%)', height: "0.7px", mt: "25px", mx: "19px" }} />
                                <Box display={"flex"} justifyContent={"center"} px={"30px"} pt={"25px"} pb={"23px"} gap={"10px"}>
                                    <Box>
                                        <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px" }}>
                                            Slower<br />Progression
                                        </Typography>
                                        <Box sx={{ overflow: "hidden", pt: "30px", pb: "37px" }}>
                                            <img src={item.slowerProgressionImage} alt="download-icon" style={{ maxWidth: "70px", maxHeight: "70px" }} />
                                        </Box>
                                        <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px", whiteSpace: "pre-line" }}>
                                            {item.footerLeft}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px" }}>
                                            Faster<br/>Progression
                                        </Typography>
                                        <Box sx={{ overflow: "hidden", pt: "30px", pb: "37px" }}>
                                            <img src={item.fasterProgressionImage} alt="download-icon" style={{ maxWidth: "70px", maxHeight: "70px" }} />
                                        </Box>
                                        <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px", whiteSpace: "pre-line" }}>
                                            {item.footerRight}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    })}
                </Box>
                <GradientCard
                    cardSx={{ mt: "24px", textAlign: "left", p: isMobileX ? "22px 50px 90px 32px" : "69px 124px 68px 75px" }}
                    content={<Trans
                        i18nKey={progressionData.notes}
                        components={{ sup: <sup /> }} />}
                />
            </Box>
        </Box>
    )
}

export default Progression